import React, { useRef, useState, useEffect } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import { authActions } from '../../actions/auth';
import { permissionsAccess } from '../../helpers/common';
import { authService } from '../../services/auth-service';
import { dashboardReset } from '../../redux/actions/dashboardAction';

import './header.scss';
import '../../assets/styles/components/_search.scss';

import MenuIcon from '../../assets/icons/menu.svg';
import LightningIcon from '../../assets/icons/lightning.svg';
import AddClientIcon from '../../assets/icons/add-client.svg';
import ProfileIcon from '../../assets/icons/profile.svg';
import LogoutIcon from '../../assets/icons/logout.svg';
import SearchIcon from '../../assets/icons/search.svg';
import {resetHandbook} from '../../redux/actions/handbookAction';
import {removeRemoteUser} from "../../redux/actions/remotelyReportsAction";
import { globalSearch } from '../../redux/actions/searchAction';
import Loader from "../ExchangeCB/Loader";
import LogoDemo from "../utilites/LogoDemo/LogoDemo";

const Header = ({ onChangeMenuState, user, message, titlePage }) => {
  const storDepartment = useSelector(({ dashboard }) => dashboard.department.label);
  const { indices } = useSelector(({ search }) => search);
  const [department, setDepartment] = useState('');
  const {isLoadingConfiguration} = useSelector(({user}) => user);
  const [term, setTerm] = useState('');

  const history = useHistory();
  const inputRef = useRef(null);
  const dispatch = useDispatch();

  const location = useLocation();
  let currentTab = 'clients';
  const showSearchLink = permissionsAccess("action.elastic.search");
  const searchStyle = showSearchLink ? '-right' : '';

  if (location.pathname.indexOf('/search-results') !== -1) {
    currentTab = location.pathname.replaceAll('/search-results/', '');
  }

  useEffect(() => {
    const localStorageDepartment = authService.getActiveCashBoxId();
    localStorageDepartment
      ? setDepartment(localStorageDepartment.label)
      : setDepartment(storDepartment);
  }, [storDepartment]);

  const handleShowSearchResults = () => {
    inputRef.current.select();
  };

  const triggerSearchInput = (e) => {
    const newTerm = (e.target.value).replace(/\+/g, '%2b');
    if (e.key === 'Enter') {
      dispatch(globalSearch({term: newTerm}));
    }
  };

  useEffect(() => {
    if (indices) {
      history.push(`/search-results/${indices}?term=${term}`);
      setTerm('')
    }
  }, [indices, history])

  const handleLogout = async () => {
    dispatch(dashboardReset());
    dispatch(resetHandbook());
    dispatch(removeRemoteUser())
    await authActions.logout();
    message && message('logout');
  };

  const onChange = (e) => {
    setTerm(e.target.value);
  };

  return (
    <header>
      { isLoadingConfiguration ? (<Loader pageRange={0}/>) :
        (<div className="header-container">
        <div className="header-container-block">
          <button className="header-menutrigger" onClick={onChangeMenuState}>
            <MenuIcon/>
          </button>
          <div className="header-logo">
            <Link to="/search-results/clients">
              <LogoDemo />
            </Link>
          </div>
        </div>
        <div className={`header-container-block${searchStyle}`}>
          {showSearchLink && (
            <div className="header-search">
              <div className="form-element header-searchInput">
                <div className="form-element-data">
                  <input
                    className="input"
                    type="text"
                    name="globalSearch"
                    id="globalSearch"
                    placeholder="Найти клиента, договор, залоговый билет, товар…"
                    autoComplete="off"
                    ref={inputRef}
                    value={term}
                    onChange={onChange}
                    onKeyUp={triggerSearchInput}
                    onFocus={handleShowSearchResults}
                  />
                  <span className="icon header-search-loupe">
                    <SearchIcon/>
                  </span>
                </div>
              </div>
            </div>
          )}
          {!isLoadingConfiguration && <h1 className='header-titlePage'>{titlePage}</h1>}
          <div className="header-actions">
            <div className="header-buttons">
              {permissionsAccess("action.branch.calculate") &&
                <Link to="/quick-calculation" className="button-primary caption">
                <span className="icon">
                  <LightningIcon/>
                </span>
                  <span>Быстрый расчёт</span>
                </Link>
              }
              {permissionsAccess("action.client.create") && (
                <Link to="/client" className="button-primary caption">
                  <span className="icon">
                    <AddClientIcon/>
                  </span>
                  <span>Добавить клиента</span>
                </Link>
              )}
            </div>
            <span className="header-action">
              <span className="icon">
                <ProfileIcon/>
              </span>
              <span>
                <div>
                  <div className="header-action-text">
                    {user ? user.lastName + ' ' + user.firstName + ' ' + user.middleName : ''}
                  </div>
                  <small>{department}</small>
                </div>
              </span>
            </span>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a className="header-action" href="#" onClick={handleLogout}>
              <span className="icon">
                <LogoutIcon/>
              </span>
            </a>
          </div>
        </div>
      </div>)
      }
    </header>
  );
};

export default Header;
